/**
 * Dynamically inject a Google Fonts <link> tag for a tenant's selected font.
 * Safe to call repeatedly — re-uses one <link id="tonneva-tenant-font"> element.
 */
export function loadTenantFont(family) {
  if (!family) return;
  const id = "tonneva-tenant-font";
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }
  link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family)}:wght@400;500;600;700;800&display=swap`;
}

/**
 * Resolve a logo URL: backend /api/uploads/... → full URL; otherwise return as-is.
 */
export function resolveLogoUrl(logoUrl) {
  if (!logoUrl) return null;
  if (logoUrl.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${logoUrl}`;
  return logoUrl;
}
